import React from 'react';
import { IButtonProps, SButton } from '../styles/Button.styled';
import Modal from '@/presentation/modal';
import { SModalBodyContainer, SModalDescription, SModalTitle, SModalIcon } from './ModalDialog.styled';

interface DialogBoxProps {
  id: string;
  showPrompt: boolean;
  icon: React.ReactNode;
  title?: string;
  children: React.ReactNode;
  onClose: () => void;
  modalButtons: Array<{
    label: string;
    action: () => void;
    color?: IButtonProps;
    id: string;
  }>;
  iserror?: boolean;
  isWaitingResponse?: boolean;
  notHasCloseIcon?: boolean;
  className?: string;
}

const ModalDialog: React.FC<DialogBoxProps> = ({
  id,
  showPrompt,
  icon,
  title = '',
  children,
  onClose,
  modalButtons,
  iserror,
  isWaitingResponse = false,
  notHasCloseIcon,
  className,
}) => {
  const renderModalButtons = () =>
    modalButtons.map((modalButton) => (
      <SButton
        key={modalButton.label}
        onClick={modalButton.action}
        color={modalButton.color?.color}
        className="hoverable--dark"
        id={modalButton.id}
      >
        {modalButton.label}
      </SButton>
    ));

  return (
    <Modal
      id={id}
      show={showPrompt}
      setShow={onClose}
      actionButtons={<>{renderModalButtons()}</>}
      isWaitingResponse={isWaitingResponse}
      notHasCloseIcon={notHasCloseIcon}
    >
      <SModalBodyContainer className={className}>
        <SModalIcon iserror={iserror}>{icon}</SModalIcon>
        <SModalTitle iserror={iserror}>{title}</SModalTitle>
        <SModalDescription iserror={iserror}>{children}</SModalDescription>
      </SModalBodyContainer>
    </Modal>
  );
};
export default ModalDialog;
